module.exports = __webpack_public_path__ + "img/A Nice Holiday.a342929f.svg";